import { Navigate } from "react-router-dom";
import { useEffect } from "react";
import { syncUserFromToken } from "../lib/api";

export default function ProtectedRoute({ children }) {
  const token = localStorage.getItem("access");

  useEffect(() => {
    // Sincronizar usuario desde el token al cargar
    if (token) {
      syncUserFromToken();
    }
  }, [token]);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
